module.exports = __webpack_public_path__ + "static/img/first.3ffbf71.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/solution/first.png
// module id = UxyQ
// module chunks = 1